import script from "./ReminderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReminderModal.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=0cb19696&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb19696"]])

export default __exports__